module.exports = __webpack_public_path__ + "img/linkedInPhoto.923768b8.jpeg";